module.exports = __webpack_public_path__ + "media/application/images/svgs/calendar-1c276f7cc50fb0a1d1936eac82e804eb.svg";